import * as tslib_1 from "tslib";
import api from '../api';
import Message from '../models/Message';
var endPoints = {
    login: 'api/login/',
    verify: 'api/login/verify',
    users: 'api/user',
    sendMessage: 'api/messages/',
    databases: 'api/login/databases',
    messages: function (userId) { return "api/messages/" + userId; },
    sections: function (userId) { return "api/user/" + userId + "/sections"; },
    readMessage: function (messageId) { return "api/messages/readed/" + messageId; }
};
var UserApi = /** @class */ (function () {
    function UserApi() {
    }
    UserApi.verify = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.verify)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, {
                                environment: data.environment,
                                userId: data.userId,
                                userName: data.userName,
                                claims: data.claims,
                                employees: data.employees || [],
                                isAuthenticated: !!data.success
                            }];
                }
            });
        });
    };
    UserApi.login = function (userName, password, database) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.login, {
                            username: userName,
                            password: password,
                            database: database
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, {
                                environment: data.environment,
                                userId: data.userId,
                                userName: data.userName,
                                claims: data.claims,
                                isAuthenticated: !!data.success,
                                employees: data.employees || []
                            }];
                }
            });
        });
    };
    UserApi.getDatabases = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.databases)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    UserApi.getUsers = function (currentUserId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.users)];
                    case 1:
                        data = (_a.sent()).data;
                        result = data;
                        return [2 /*return*/, result.filter(function (i) { return i.id !== currentUserId; })];
                }
            });
        });
    };
    UserApi.getMessages = function (userId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.messages(userId))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (i) { return new Message(i); })];
                }
            });
        });
    };
    UserApi.sendMessage = function (message) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.put(endPoints.sendMessage, message)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Message(data)];
                }
            });
        });
    };
    UserApi.markMessageReaded = function (messageId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(endPoints.readMessage(messageId))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Message(data)];
                }
            });
        });
    };
    UserApi.getAvatarUrl = function (userId) {
        return api.defaults.baseURL + "/api/user/avatar/" + userId;
    };
    UserApi.logout = function () {
        api.post('logout').then(function (res) {
            window.location.href = api.defaults.baseURL + '/';
        });
    };
    UserApi.getSections = function (userId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(endPoints.sections(userId))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.map(function (i) { return i; })];
                }
            });
        });
    };
    return UserApi;
}());
export default UserApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/UserApi.ts
// module id = 91
// module chunks = 0